

























































import * as _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { UserInfo } from '../../../build/swagger-code-extranet-api-definition';
import ApplicationBarStoreModule from '../../store/modules/applicationBar.module';
import LogoutCheckModal from './LogoutCheckModal.vue';

@Component({
  components: {
    LogoutCheckModal,
  },
})
export default class UserItem extends Vue {
  @Prop({ required: true }) public user: UserInfo;
  @Prop(String) public webCatalogUrl: string;
  @Prop(String) public extranetUrl: string;
        @Prop(String) public loginUrl: string;
        @Prop(String) public logoutUrl: string;
        @Prop(String) public logoutImpersonationUrl: string;

        applicationBarStore: ApplicationBarStoreModule = getModule(ApplicationBarStoreModule, this.$store);

        showModal = false;

        public created() {
            this.applicationBarStore.loadAccountEntries();
        }

        get darkLayer(): HTMLElement {
            return this.$refs.userMenuDarkLayer as HTMLElement;
        }

        get userLoggedIn() {
          return !!this.user;
        }

        public onUserMenuShow() {
            this.darkLayer.setAttribute('show', '');
            this.$emit('closeSideMenu');
        }

        public onUserMenuHide() {
            this.darkLayer.removeAttribute('show');
        }

        get isOCIUser() {
            return this.userLoggedIn && this.user.isOciUser;
        }

        get isCatalogAdministrator() {
            return this.user.isCatalogAdministrator;
        }

        get administrationTitle() {
          return 'extranetSecurity.administration';
        }

        get editUserLinkTitle() {
            if (this.userLoggedIn && this.user.isFieldWorker) {
                return 'extranetSecurity.editUsers';
            } else {
                return 'extranetSecurity.editSubusers';
            }
        }

        logout(event: Event) {
            event.preventDefault();
            if (this.applicationBarStore.basketSummaryForAllBaskets && this.applicationBarStore.basketSummaryForAllBaskets.basketSummaries) {
                this.showModal = _.some(this.applicationBarStore.basketSummaryForAllBaskets.basketSummaries, 'containsConfiguratedArticles');

                if (!this.showModal) {
                    // Basket is correct (not undefined) but no configured articles
                    this.redirectToLogout();
                }
            } else {
                this.redirectToLogout();
            }
        }

        close() {
            this.showModal = false;
        }

        redirectToLogout() {
            window.location.href = this.userLoggedIn && this.user.isImpersonated ? this.logoutImpersonationUrl : this.logoutUrl;
        }
    }
